import React, { useEffect, useImperativeHandle, useState } from "react";
import {
  Form,
  Row,
  Col,
  Space,
  DatePicker,
  Input,
  Button,
  Spin,
  message,
  Typography,
  Divider,
} from "antd";

import { InputFields } from "components/common";
import {
  dataFieldsCV as inputFieldsInit,
  dataFieldsHTK,
  dataFieldsL,
  dataFieldsTC,
  dataFieldsCV,
  dataFieldsLV,
} from "./config";

import { employeeService } from "api";
import dayjs from "dayjs";
import moment from "moment";
import {
  convertIosStringToDate,
  formatDateToString,
} from "../../../../../../../helper/common";
import { ref } from "yup";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../redux/hooks";
import {
  getChucVuAPI,
  getLCVAPI,
  getLHDAPI,
  getPhongBanAPI,
  getSGAPI,
  getWord,
  setEmployee,
} from "../../../../../../../redux/reducer/employee";
import { setSoHopDong } from "redux/reducer/employee";
import { RefreshIconSVG } from "../../../../../../../assets";
import TableInputAdd from "../../../../../../Examination/components/InforDetail/DetailTabInfo/components/ConcludePrecription/ConcludeIcd/TableInputAdd/TableInputAdd";
import { columnsIcdTableMenu } from "../../../../../../Examination/components/InforDetail/DetailTabInfo/components/ConcludePrecription/ConcludeIcd/ConcludeIcd.config";
import Notification from "../../../../../../../components/common/notification/notification";
import { RangePickerProps } from "antd/es/date-picker";
import { DataFormField } from "../../../../../../../types/models/input-field-type";
import {
  FIELD_TYPE,
  FORMAT_TIME,
  tabKeys,
} from "../../../../../../../types/enums";
import { ColumnsEdit } from "../../../../../../../types/models/column-table-edit";
import { async } from "q";
const {
  INPUT,
  DATE,
  DATE_DISABLE_NO_DAY,
  COMBO_BOX,
  AUTO_COMPLETE,
  CURRENCY,
  NUMBER,
  DATE_PRE,
  DATE_ON,
  DATE_DISABLE,
} = FIELD_TYPE;
const FormAdd = (props) => {
  const onChangePC = (e) => {
    let totalCB = Number(form.getFieldValue("luongCoBan")) ?? 0;
    let total = totalCB + Number(e);
    form.setFieldsValue({
      luongDongBHXH: total,
    });
  };

  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = (
      currentDate
    ) => {
      const endDay = form.getFieldValue("ngayHetHD");
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = (currentDate) => {
      const start = form.getFieldValue("ngayBatDau");
      if (start) {
        return currentDate < start;
      }
    };
    dataFieldsCV.find((e) => e.name == "ngayBatDau").disabledDate =
      disabledDateStart;
    dataFieldsCV.find((e) => e.name == "ngayHetHD").disabledDate =
      disabledDateEnd;
    setFieldInfo([...dataFieldsCV]);
  }, []);
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = (
      currentDate
    ) => {
      const endDay = form.getFieldValue("apDungDenNgay");
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = (currentDate) => {
      const start = form.getFieldValue("apDungTuNgay");
      if (start) {
        return currentDate < start;
      }
    };
    dataFieldsHTK.find((e) => e.name == "apDungTuNgay").disabledDate =
      disabledDateStart;
    dataFieldsHTK.find((e) => e.name == "apDungDenNgay").disabledDate =
      disabledDateEnd;
    setFieldInfoHTK([...dataFieldsHTK]);
  }, []);
  const onChangeCB = (e) => {
    let totalPC = Number(form.getFieldValue("phuCapTrachNhiem")) ?? 0;
    let total = totalPC + Number(e);
    form.setFieldsValue({
      luongDongBHXH: total,
    });
  };
  const onChangeLHD = (e) => {
    const getNumberContract = async () => {
      try {
        const num = await employeeService.getNumberContract(idEmp);
        const res = await employeeService.getIdLHD(e);
        let soHopDong = num.body + res.maLoai;
        form.setFieldValue("soHopDong", soHopDong);
      } catch (error) {
        Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
      }
    };
    getNumberContract();
    let numberHD = form.getFieldValue("soHopDong") ?? null;
    form.setFieldsValue({
      soHopDong: numberHD,
    });
  };
  const handleDiaChiLamViec = (e) => {
    const id = form.getFieldValue("idDiaChiLamViec");
    const selectedDiaChi = employees.wordAddress.find(
      (item) => item.id === id
    );
    if (selectedDiaChi) {
      form.setFieldsValue({ idDiaChiLamViecTA: selectedDiaChi.diaChiLamViecTA });
    }
  };
  const dataFieldsCV: ColumnsEdit = [
    {
      type: COMBO_BOX,
      label: "Loại công việc",
      name: "loaiCongViec",
      disable: false,
      expand: false,
      options: [
        { value: "1", label: "Công việc" },
        { value: "2", label: "Nghỉ thai sản" },
        { value: "3", label: "Nghỉ không lương" },
      ],
      rules: [{ required: true, message: "Chưa nhập loại công việc" }],
    },
    {
      type: COMBO_BOX,
      label: "Phòng ban",
      name: "idPhongBan",
      disable: false,
      expand: false,
      rules: [{ required: true, message: "Chưa chọn phòng ban" }],
    },

    {
      type: COMBO_BOX,
      label: "Chức vụ",
      name: "idChucVu",
      disable: false,
      expand: false,
      rules: [{ required: true, message: "Chưa nhập chức vụ" }],
    },
    {
      type: INPUT,
      label: "Chức vụ TA",
      name: "chucVuTA",
      disable: false,
      expand: false,
    //  rules: [{required: true, message: "Chưa nhập nhóm công việc"}],
    },
    {
      type: INPUT,
      label: "Số hợp đồng",
      name: "soHopDong",
      disable: true,
      expand: false,
    },
    {
      type: COMBO_BOX,
      label: "Loại hợp đồng",
      name: "idLoaiHopDong",
      disable: false,
      expand: false,
      onChange: onChangeLHD,
      rules: [{ required: true, message: "Chưa chọn loại nhập đồng" }],
    },
    {
      type: COMBO_BOX,
      label: "Số giờ/tuần",
      name: "soGioTrongTuan",
      disable: false,
      expand: false,
      rules: [{ required: true, message: "Chưa nhập số giờ trên tuần" }],
    },

    {
      type: DATE_DISABLE_NO_DAY,
      label: "Ngày bắt đầu HD",
      name: "ngayBatDau",
      disable: false,

      disableDate: false,
      optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
      rules: [{ required: true, message: "Chưa nhập ngày bắt đầu hợp đồng" }],
    },

    {
      type: DATE_DISABLE_NO_DAY,
      label: "Ngày hết HD",
      name: "ngayHetHD",
      disable: false,
      disableDate: false,
      optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
    },
    {
      type: INPUT,
      label: "Lý do",
      name: "lyDo",
      disable: false,
      expand: false,
    },
    {
      type: COMBO_BOX,
      label: "Địa chỉ làm việc",
      name: "idDiaChiLamViec",
      disable: false,
      expand: false,
      onChange : handleDiaChiLamViec
    },
    {
      type: COMBO_BOX,
      label: "Địa chỉ làm việc TA",
      name: "idDiaChiLamViecTA",
      disable: false,
      expand: false,
    },
    {
      type: INPUT,
      label: "Ghi chú",
      name: "ghiChu",
      disable: false,
      expand: false,
    },
    // {
    //   type: INPUT,
    //   label: "Chức vụ Tiếng Anh",
    //   name: "chucVuTA",
    //   disable: false,
    //   expand: false,
    // },
  ];
  const dataFieldsL: DataFormField[] = [
    {
      type: CURRENCY,
      label: "Lương đóng BHXH",
      name: "luongDongBHXH",
      disable: true,
      expand: false,
    },
    {
      type: COMBO_BOX,
      label: "Tham gia BHXH",
      name: "thamGiaBHXH",
      disable: false,
      expand: false,
      options: [
        { value: 0, label: "Không" },
        { value: 1, label: "Có" },
      ],
    },
    {
      type: CURRENCY,
      label: "Lương thử việc",
      name: "luongThuViec",
      disable: false,
      expand: false,
    },
    {
      type: CURRENCY,
      label: "Phụ cấp trách nhiệm",
      name: "phuCapTrachNhiem",
      disable: false,
      expand: false,
      onChange: onChangePC,
    },
    {
      type: CURRENCY,
      label: "Lương cơ bản",
      name: "luongCoBan",
      disable: false,
      expand: false,
      onChange: onChangeCB,
    },
  ];
  const dataFieldsTC: DataFormField[] = [
    {
      type: CURRENCY,
      label: "Hỗ trợ xăng xe đi lại",
      name: "hoTroXangXeDiLai",
      disable: false,
      expand: false,
    },
    {
      type: CURRENCY,
      label: "Hỗ trợ điện thoại",
      name: "hoTroDienThoai",
      disable: false,
      expand: false,
    },

    {
      type: CURRENCY,
      label: "Hỗ trợ trang phục",
      name: "hoTroTrangPhuc",
      disable: false,
      expand: false,
    },
    {
      type: CURRENCY,
      label: "Hỗ trợ chỗ ở",
      name: "hoTroChoO",
      disable: false,
      expand: false,
    },
    {
      type: CURRENCY,
      label: "Hỗ trợ ăn trưa",
      name: "hoTroAnTrua",
      disable: false,
      expand: false,
    },
    {
      type: CURRENCY,
      label: "Thưởng hiệu suất công việc",
      name: "thuongHieuSuat",
      disable: false,
      expand: false,
    },
  ];
  const dataFieldsLV: DataFormField[] = [
    {
      type: INPUT,
      label: "Số ngày làm việc",
      name: "soNgayLamViec",
      disable: false,
      rules: [
        {
          pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
          message: "Chỉ cho phép nhập số",
        },
      ],
    },
    {
      type: INPUT,
      label: "Số ngày làm việc nội trú",
      name: "soNgayLamViecNoiTru",
      disable: false,
      rules: [
        {
          pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
          message: "Chỉ cho phép nhập số",
        },
      ],
    },
    {
      type: INPUT,
      label: "Số ngày làm việc ngoại trú",
      name: "soNgayLamViecNgoaiTru",
      disable: false,
      rules: [
        {
          pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
          message: "Chỉ cho phép nhập số",
        },
      ],
    },
  ];
  const { data, closeModal, type, getListApi,activeTabKey, setCurrentPage } = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  let idEmp = useAppSelector((state) => state.employeesReducer.idEmp);
  const employees = useAppSelector((state) => state.employeesReducer);
  const [fieldInfo, setFieldInfo] = useState(dataFieldsCV);
  const [fieldInfoHTK, setFieldInfoHTK] = useState(dataFieldsHTK);
  const [field, setField] = useState(dataFieldsL);
  const [fieldTC, setFieldTC] = useState(dataFieldsTC);
  const [fieldLV, setFieldLV] = useState(dataFieldsLV);
  const [soHD, setSoHD] = useState<any>(null);
  const [dataSource, setDataSource] = useState<any>([]);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (type === "Thêm") {
      form.resetFields();
      form.setFieldValue("idNhanVien", idEmp);
      const updatedFieldsCV = fieldInfo.map((field) => {
        if (field.name === "soHopDong" || field.name === "idDiaChiLamViecTA") {
          return {
            ...field,
            disable: true,
          };
        } else {
          return {
            ...field,
            disable: false,
          };
        }
      });
      const updatedFieldInfoHTK = fieldInfoHTK.map((field) => ({
        ...field,
        disable: false,
      }));
      const updatedField = field.map((field) => ({
        ...field,
        disable: false,
      }));
      const updatedFieldTC = fieldTC.map((field) => ({
        ...field,
        disable: false,
      }));
      const updatedFieldLV = fieldLV.map((field) => ({
        ...field,
        disable: false,
      }));
      setFieldTC(updatedFieldTC);
      setFieldInfo(updatedFieldsCV);
      setFieldInfoHTK(updatedFieldInfoHTK);
      setField(updatedField);
      setFieldLV(updatedFieldLV);
      if (idEmp == null) {
        message.warning("vui lòng chọn nhân viên để thêm hợp đồng");
        setLoading(false);
        closeModal();
      }
      getNumberContract(idEmp);
    }
    if(type === "Sửa") {
      form.setFieldsValue(data);
      form.setFieldValue("id", data.id);
      if(data?.trangThai === 1)
      {
        const updatedFieldsCV = fieldInfo.map((field) => {
          if (field.name === "idDiaChiLamViec" || field.name === "ngayHetHD" || field.name === "chucVuTA") {
            return {
              ...field,
              disable: false,
            };
          } else {
            return {
              ...field,
              disable: true,
            };
          }
        });
        const updatedFieldInfoHTK = fieldInfoHTK.map((field) => ({
          ...field,
          disable: true,
        }));
        const updatedField = field.map((field) => ({
          ...field,
          disable: true,
        }));
        const updatedFieldTC = fieldTC.map((field) => ({
          ...field,
          disable: true,
        }));
        const updatedFieldLV = fieldLV.map((field) => ({
          ...field,
          disable: true,
        }));
        setFieldTC(updatedFieldTC);
        setFieldInfo(updatedFieldsCV);
        setFieldInfoHTK(updatedFieldInfoHTK);
        setField(updatedField);
        setFieldLV(updatedFieldLV);
        // form.setFieldsValue(data);
        // form.setFieldValue("id", data.id);
    }
    if(data?.trangThai === 2)
    {
      const updatedFieldsCV = fieldInfo.map((field) => ({
        ...field,
        disable: true,
      }));
      const updatedFieldInfoHTK = fieldInfoHTK.map((field) => ({
        ...field,
        disable: true,
      }));
      const updatedField = field.map((field) => ({
        ...field,
        disable: true,
      }));
      const updatedFieldTC = fieldTC.map((field) => ({
        ...field,
        disable: true,
      }));
      const updatedFieldLV = fieldLV.map((field) => ({
        ...field,
        disable: true,
      }));
      setFieldTC(updatedFieldTC);
      setFieldInfo(updatedFieldsCV);
      setFieldInfoHTK(updatedFieldInfoHTK);
      setField(updatedField);
      setFieldLV(updatedFieldLV);
    //  form.setFieldsValue(data);
     // form.setFieldValue("id", data.id);
    }
    }
  }, [data?.trangThai,type]);
  // useEffect(() => {
  //   //console.log("ádasdasd",activeTabKey);
  //   if (activeTabKey !== tabKeys.EMPLOYEE.CONTRACT) {
  //     //form.resetFields();
  //   }
  // }, [activeTabKey]);
  useEffect(() => {
    dispatch(
      getChucVuAPI({
        page: 1,
        limit: 1000,
      })
    );
    dispatch(
      getSGAPI({
        page: 1,
        limit: 1000,
      })
    );
    dispatch(
      getPhongBanAPI({
        page: 1,
        limit: 1000,
      })
    );

    dispatch(
      getWord({
        page: 1,
        limit: 1000,
      })
    );
    dispatch(
      getLHDAPI({
        page: 1,
        limit: 1000,
      })
    );
  }, []);
  useEffect(() => {
    setOptionsCVFields(employees.chucVuList, "idChucVu");
  }, [employees.chucVuList]);
  useEffect(() => {
    setOptionsPBFields(employees.phongBanList, "idPhongBan");
  }, [employees.phongBanList]);
  useEffect(() => {
    setOptionsWordFields(employees.wordAddress, "idDiaChiLamViec");
  }, [employees.wordAddress]);
  useEffect(() => {
    setOptionsLHDields(employees.LHDList, "idLoaiHopDong");
  }, [employees.LHDList]);
  useEffect(() => {
    setOptionsSGFields(employees.SGList, "soGioTrongTuan");
  }, [employees.SGList]);
  const setOptionsCVFields = (list, tenChucVu) => {
    setFieldInfo(prevFieldInfo => {
      const updatedFieldInfo = prevFieldInfo.map(field => {
        if (field.name === tenChucVu) {
          return {
            ...field,
            options: list?.map(item => ({
              value: item.id,
              label: item.tenChucVu,
            })),
          };
        }
        return field;
      });
      return updatedFieldInfo;
    });
  };
  const setOptionsPBFields = (list, tenPhongBan) => {
    setFieldInfo(prevFieldInfo => {
      const updatedFieldInfo1 = prevFieldInfo.map(field => {
        if (field.name === tenPhongBan) {
          return {
            ...field,
            options: list?.map(item => ({
              value: item.id,
              label: item.tenPhongBan,
            })),
          };
        }
        return field;
      });
      return updatedFieldInfo1;
    });
  };
  
  // const setOptionsPBFields = (list, tenPhongBan) => {
  //   if (fieldInfo.find((field) => field.name === tenPhongBan)) {
  //     fieldInfo.find((field) => field.name === tenPhongBan).options = list?.map(
  //       (item) => ({
  //         value: item.id,
  //         label: item.tenPhongBan,
  //       })
  //     );
  //     setFieldInfo([...fieldInfo]);
  //   }
  // };
  const setOptionsWordFields = (list, diaChi) => {
    setFieldInfo(prevFieldInfo => {
      let keyCounter = 1;
      const updatedFieldInfo2 = prevFieldInfo.map(field => {
        if (field.name === diaChi) {
          return {
            ...field,
            options: list?.map(item => ({
              key: keyCounter ++,
              value: item.id,
              label: item.diaChiLamViec,
            })),
          };
        }
        return field;
      });
      return updatedFieldInfo2;
    });
  };
  const setOptionsLHDields = (list, tenLoai) => {
    setFieldInfo(prevFieldInfo => {
      const updatedFieldInfo3 = prevFieldInfo.map(field => {
        if (field.name === tenLoai) {
          return {
            ...field,
            options: list?.map(item => ({
              value: item.id,
              label: item.tenLoai,
            })),
          };
        }
        return field;
      });
      return updatedFieldInfo3;
    });
  };
  const setOptionsSGFields = (list, soGioTuan) => {
    setFieldInfo(prevFieldInfo => {
      const updatedFieldInfo3 = prevFieldInfo.map(field => {
        if (field.name === soGioTuan) {
          return {
            ...field,
            options: list?.map(item => ({
              value: item.id,
              label: item.soGioTuan,
            })),
          };
        }
        return field;
      });
      return updatedFieldInfo3;
    });
  };
  const getNumberContract = async (id) => {
    if (id) {
      try {
        const res = await employeeService.getNumberContract(id);
        setSoHD(res.body);
        form.setFieldValue("soHopDong", res.body);
      } catch (error) {
        Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
      }
    } else {
      Notification("error", "Chưa có thông tin nhân viên");
    }
  };

  const addApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
        idNhanVien: idEmp,
      };
      const res = await employeeService.editContract(params);
      if (res.code === "400") {
        Notification("error", res.message);
      } else {
        form.resetFields();
        Notification("success", `Đã thêm mới thành công `);
      }
      setLoading(false);
      closeModal();
      await getListApi(idEmp);
    } catch (error) {
      setLoading(false);
      Notification("error", `Đã có lỗi khi thêm mới hợp đồng`);
    }
  };
  const editApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
        id: data.id,
        idNhanVien: idEmp,
      };
      const res = await employeeService.editContract(params);
      if (res.code === "400") {
        Notification("error", res.message);
      } else {
        Notification("success", `Đã chỉnh sửa thành công thành công  `);
      }
      setLoading(false);
      closeModal();
      await getListApi(idEmp);
    } catch (error) {
      setLoading(false);

      Notification("error", `Đã có lỗi khi sửa thông tin hợp đồng `);
    }
  };
  const clearFields = async () => {
    form.resetFields();
  };
  useEffect(() => {
    form.setFieldsValue({
      ...data,
      ngayBatDau: data?.ngayBatDau ? dayjs(data?.ngayBatDau) : null,
      ngayHetHD: data?.ngayHetHD ? dayjs(data?.ngayHetHD) : null,
      apDungTuNgay: data?.apDungTuNgay ? dayjs(data?.apDungTuNgay) : null,
      apDungDenNgay: data?.apDungDenNgay ? dayjs(data?.apDungDenNgay) : null,
    //  soNgayLamViec: data?.soNgayLamViec ? dayjs(data?.soNgayLamViec) : null,
    //  soNgayLamViecNoiTru: data?.soNgayLamViecNoiTru ? dayjs(data?.soNgayLamViecNoiTru) : null,
    //  soNgayLamViecNgoaiTru: data?.soNgayLamViecNgoaiTru ? dayjs(data?.soNgayLamViecNgoaiTru) : null,
    });
  }, [data]);
  // useEffect(() => {

  //   form.setFieldsValue({
  //       ...data,

  //     apDungTuNgay: data?.apDungTuNgay
  //           ? dayjs(data.apDungTuNgay)
  //           : null,
  //     apDungDenNgay: data?.apDungDenNgay
  //           ? dayjs(data.apDungDenNgay)
  //           : null,

  //     });

  // }, [data]);

  const onFinish = (values) => {
    if (type == "Thêm") {
      addApi();
    } else {
      editApi();
    }
  };
  const columnsContract = columnsIcdTableMenu.map((col) => {
    // if (col.dataIndex === 'maIcd') {
    //   return {
    //     ...col,
    //     options: [
    //       ...icdList.map((it, idx) => ({
    //         value: it.maIcd,
    //         label: it.maIcd
    //       }))
    //     ],
    //     onChange: onIcdChange
    //   }
    // }
    // else if (col.dataIndex === "tenIcd") {
    //   return {
    //     ...col,
    //     options: [
    //       ...icdList.map(it => ({
    //         value: it.tenIcd,
    //         label: it.tenIcd
    //       }))
    //     ]
    //   };
    // } else return col;
  });
  return (
    <Spin spinning={loading}>
      <div>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" className="prescription-space">
            <div>
              <Row justify={"space-between"} align={"middle"}>
                <Col>
                  <Typography
                    style={{
                      fontWeight: "700",
                      fontSize: 16,
                      color: "#00B335",
                      marginBottom: 12,
                    }}
                  >
                    {" "}
                    Thông tin công việc
                  </Typography>
                </Col>
                <Row gutter={[16, 8]}>
                  <InputFields data={fieldInfo}></InputFields>
                </Row>
              </Row>
            </div>
            <Divider />
            <div>
              <Row justify={"space-between"} align={"middle"}>
                <Col>
                  <Typography
                    style={{
                      fontWeight: "700",
                      fontSize: 16,
                      color: "#00B335",
                      marginBottom: 12,
                    }}
                  >
                    {" "}
                    Lương
                  </Typography>
                </Col>
                <Row gutter={[16, 8]}>
                  <InputFields data={field}></InputFields>
                </Row>
              </Row>
            </div>
            <Divider />
            <div>
              <Row justify={"space-between"} align={"middle"}>
                <Col>
                  <Typography
                    style={{
                      fontWeight: "700",
                      fontSize: 16,
                      color: "#00B335",
                      marginBottom: 12,
                    }}
                  >
                    Trợ cấp
                  </Typography>
                </Col>
                <Row gutter={[16, 8]}>
                  <InputFields data={fieldTC}></InputFields>
                </Row>
              </Row>
            </div>
            <Divider />
            <div>
              <Row justify={"space-between"} align={"middle"}>
                <Col>
                  <Typography
                    style={{
                      fontWeight: "700",
                      fontSize: 16,
                      color: "#00B335",
                      marginBottom: 12,
                    }}
                  >
                    Hỗ trợ khác
                  </Typography>
                </Col>
                <Row gutter={[16, 8]}>
                  <InputFields data={fieldInfoHTK}></InputFields>
                </Row>
              </Row>
            </div>
            <Divider />
            <div>
              <Row justify={"space-between"} align={"middle"}>
                <Col>
                  <Typography
                    style={{
                      fontWeight: "700",
                      fontSize: 16,
                      color: "#00B335",
                      marginBottom: 12,
                    }}
                  >
                    Số ngày làm việc
                  </Typography>
                </Col>
                <Row gutter={[16, 8]}>
                  <InputFields data={fieldLV}></InputFields>
                </Row>
              </Row>
            </div>
            <Divider />
            {/*<TableInputAdd*/}
            {/*    loading={loading}*/}
            {/*    column={columnsContract}*/}
            {/*    data={dataSource}*/}
            {/*    setData={setDataSource}*/}
            {/*    pagination={false}*/}

            {/*/>*/}
            <Row justify="end" style={{ marginTop: 12 }}>
              <Col>
                <Space>
                  <Button
                    className="btn-sub"
                    type="primary"
                    icon={<RefreshIconSVG />}
                    onClick={clearFields}
                  >
                    Làm mới
                  </Button>
                  <Button
                    onClick={closeModal}
                    style={{
                      backgroundColor: "red",
                      borderColor: "red",
                      color: "white",
                    }}
                  >
                    Hủy bỏ
                  </Button>
                  <Button htmlType="submit" type="primary">
                    Lưu lại
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </div>
    </Spin>
  );
};
export default FormAdd;
